import React from 'react'
import { useTranslation } from 'react-i18next'

import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

import { Logo } from '../Logo/Logo'

export const Footer = () => {
  const currentYear = new Date().getFullYear()
  const { t } = useTranslation()

  return (
    <Grid container id="footer-container" flexDirection="column" my={2}>
      <Grid
        container
        item
        id="logo-container"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="subtitle2" color="#000" sx={{ mr: 0.5 }}>
          {t('Powered by')}
        </Typography>
        <Logo />
      </Grid>
      <Grid
        container
        item
        display="flex"
        id="copyright-container"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="caption" sx={{ mr: 1 }}>
          © {currentYear} Intelibly
        </Typography>
        <Link
          aria-label="privacy policy"
          variant="caption"
          href="https://intelibly.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('Privacy Policy')}
        </Link>
      </Grid>
    </Grid>
  )
}
